import * as types from '../types/sijilat';

const initialState = {
  isFetchingCRList: false,
  CRList: [],
  CRListError: null
}

export default function sijilatInfo(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_SIJILAT_CR_LIST_REQ:
      return {
        ...initialState,
        isFetchingCRList: true,
      };
    case types.FETCH_SIJILAT_CR_LIST_RES:
      return {
        ...initialState,
        CRList: action.data,        
      };
    case types.FETCH_SIJILAT_CR_LIST_ERR:
      return {
        ...initialState,
        CRListError: action.error,
      };
    default:
      return state;
  }
}